import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { toast } from "sonner";
import { api, SESSION_EXPIRED } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    // No session stored: skip the call instead of producing a 401.
    if (!localStorage.getItem("ccf_token") && !localStorage.getItem("ccf_refresh")) {
      setUser(null);
      setLoading(false);
      return;
    }
    try {
      const res = await api.get("/auth/me");
      setUser(res.data);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  useEffect(() => {
    const onExpired = () => {
      setUser(null);
      toast.info("Tu sesión venció, ingresá de nuevo", { id: "session-expired" });
    };
    window.addEventListener(SESSION_EXPIRED, onExpired);
    return () => window.removeEventListener(SESSION_EXPIRED, onExpired);
  }, []);

  const loginToken = async (token, refresh) => {
    localStorage.setItem("ccf_token", token);
    if (refresh) localStorage.setItem("ccf_refresh", refresh);
    await checkAuth();
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("ccf_token");
    localStorage.removeItem("ccf_refresh");
    setUser(null);
    window.location.href = "/";
  };

  return (
    <AuthContext.Provider value={{ user, setUser, loading, checkAuth, loginToken, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
